module EEX.McEc.Commands {

    export class ReadPrivateKeyFileCommand {

        public read(file: File, success: (privateKeyPem: any) => void, error: (exception: any) => void) {
            let reader = new FileReader();
            let data: any;

            reader.onload = e => {
                try {
                    data = (<any>e.target).result;
                    success(data);
                } catch (ex) {
                    error(ex); 
                }
            };
            try {
                reader.readAsText(file);
            } catch (ex) {
                error(ex);
            }
        }
    }
}
